import debounce from './debounce';
import { updateStripePaymentRequestButton } from './payments/stripe/payment-button';
import {
  checkForSubscription,
  clickOnPlan,
  formatDateOptions,
  setupUserInfoValidation,
  updateShowPaymentForm,
  validateDOB,
} from './subscribe-utils';
import { ready } from './utils';

/*
 * Business logic for subscribe/promotion and subscribe/one pages.
 * Util functions found in subscribe-utils.js
 */
ready(() => {
  /* Validation logic for subscribe/promotion and subscribe/one */
  const accountInfoForm = document.querySelector('.signup-form');
  // Don't hit the server to validate if the form has been prefilled with a known good email
  if (accountInfoForm && !accountInfoForm.classList.contains('prefilled_form')) {
    accountInfoForm.addEventListener('change', debounce(checkForSubscription, 300));
  }
  if (accountInfoForm) {
    // input validation for account info
    setupUserInfoValidation();
  }

  // update stripe payment button for offer page
  const selectedPlan = document.querySelector('.subscribe-plan.selected');
  let selectedPlanDataId;

  if (selectedPlan) {
    selectedPlanDataId = selectedPlan.dataset.planId;
    const initialOfferElement = selectedPlan.querySelector('.price-container.--promo .price');
    if (initialOfferElement && initialOfferElement.dataset.planAmount) {
      const offerAmount = parseFloat(initialOfferElement.dataset.planAmount);

      updateStripePaymentRequestButton({
        amount: offerAmount,
        label: 'Subscription to The Information',
      });
    } else {
      updateStripePaymentRequestButton(selectedPlanDataId);
    }
  }

  // show birthday form if offer is yp199 or yp225 (case-insensitive)
  const offer = new URLSearchParams(window.location.search).get('offer');
  if (offer && ['yp199', 'yp225'].includes(offer.toLowerCase())) {
    document
      .querySelectorAll('.show-for-yp')
      .forEach((element) => element.classList.remove('hidden'));
    validateDOB(); // this should initially always be invalid for an empty form
  }

  // birthday validation for promotion and subscribe one page
  const birthdayContainer = $('.birthday-container');
  if (birthdayContainer) {
    const month = $('#select-month');
    const day = $('#select-day');
    const year = $('#select-year');

    // perform magic to display correct num of days in each month
    month.on('change', () => formatDateOptions(month));

    // Validate DOB whenever a select option changes
    month.on('change', validateDOB);
    day.on('change', validateDOB);
    year.on('change', validateDOB);
  }

  /* plan selection logic specific to subscribe/one page */
  const plans = document.querySelectorAll('.subscribe-plan.plan-option');
  if (plans.length === 0) {
    return; // we'll stop here if we're not on the subscribe/one page
  }

  // Update the "Today's Total" based on the plan
  const todaysTotalPrice = selectedPlan.dataset.todaysTotal;
  document.querySelector('#subscribe-todays-total-price').innerHTML = todaysTotalPrice;

  // open birthday module if necessary
  if (['yp199', 'yp225'].includes(selectedPlanDataId)) {
    document
      .querySelectorAll('.show-for-yp')
      .forEach((element) => element.classList.remove('hidden'));
    validateDOB(); // this should initially always be invalid for an empty form
  }

  plans.forEach((plan) => {
    plan.addEventListener('click', (e) => {
      const selectedPlan = e.target.closest('.subscribe-plan');
      clickOnPlan(plans, selectedPlan);
    });
  });

  // Wait until the Stripe iframe loads and then update stripe with the currently selected plan
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.childNodes.length > 0) {
        updateStripePaymentRequestButton(selectedPlanDataId);
        observer.disconnect();
      }
    });
  });
  const paymentForm = document.querySelector('#payment-request-button');
  observer.observe(paymentForm, { childList: true, subtree: true });
  updateShowPaymentForm();
});
